import { Combobox } from "@/components/Combobox";
import { type ComboboxOption } from "@/components/Combobox/types";
import { type graphql } from "@/graphql";

export type SexClass = ReturnType<typeof graphql.scalar<"SupplyChainSexClassEnumType">>;

type Props = {
  id?: string;
  selected: Array<SexClass>;
  onSelect: (values: Array<SexClass>) => void;
  className?: string;
  inputRef?: React.Ref<HTMLButtonElement>;
};

export function SexPicker({ id, selected, onSelect, className, inputRef }: Props) {
  return (
    <Combobox
      type="multi"
      id={id}
      name="sex"
      options={sexOptions}
      selected={selected}
      onChange={onSelect}
      className={className}
      inputRef={inputRef}
    />
  );
}

export const sexOptions: Array<ComboboxOption<SexClass>> = [
  { value: "HEIFER", label: "Heifer" },
  { value: "STEER", label: "Steer" },
  { value: "MIXED", label: "Mixed" },
];
